var exports = {
  "N": "Link__Q4YH9u",
};

module.exports = exports;
